import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function EmotionalHook() {
  return <section className="bg-[#9B4D4D] py-16 text-white text-center px-4" data-id="element-37">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto" data-id="element-38">
        <h2 className="text-3xl md:text-4xl font-serif font-medium mb-6 leading-relaxed" data-id="element-39">
          Si sientes que tu mente nunca se apaga… esto es para ti
        </h2>

        <div className="space-y-4 text-lg font-light text-white/90 mb-10" data-id="element-40">
          <p className="font-medium text-white text-xl" data-id="element-41">
            Tal vez te pasa esto todos los días:
          </p>

          <div className="bg-white/10 rounded-xl p-5 text-left max-w-lg mx-auto border border-white/10 mt-6" data-id="element-42">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-43">
              {['Piensas demasiado incluso cuando intentas descansar', 'Tu mente sigue activa antes de dormir', 'Sientes ansiedad constante o estrés mental', 'Te cuesta relajarte y disfrutar el presente', 'Estás agotado emocionalmente', 'Quieres sentir paz mental pero no sabes cómo lograrlo'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-44">
                  <div className="h-1.5 w-1.5 rounded-full bg-[#C4973B] mt-2 flex-shrink-0" data-id="element-45" />
                  <span className="text-sm leading-snug" data-id="element-46">{item}</span>
                </div>)}
            </div>
          </div>

          <p className="font-bold text-white text-xl pt-6" data-id="element-47">Y lo peor…</p>
          <p data-id="element-48">
            Es que mientras más intentas "calmarte", más acelerada se siente tu
            mente.
          </p>
        </div>

        <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#C4973B] text-white font-bold py-4 px-8 rounded-full shadow-lg hover:bg-[#B08632] hover:scale-105 transition-all text-lg" data-id="element-49">
          Quiero calmar mi mente hoy
          <ArrowRight className="h-5 w-5" data-id="element-50" />
        </a>
      </motion.div>
    </section>;
}